import { IInvestedAssetsNormalized } from '../../../../store/customerDetail/types';

export const transformProduct = (product: any): IInvestedAssetsNormalized => {
  return {
    marketTypeNormalized: product.productType,
    colorNormalized: product.colorNormalized,
    marketNameNormalized: product.nameNormalized,
    valueNormalized: product.value,
    percentageNormalized: product.percentage,
  };
};
